import { HashRouter, Route, Routes } from 'react-router-dom';
import { Layout } from './Layout';
import { TodayScreen } from '../screens/TodayScreen';
import { SleepScreen } from '../screens/SleepScreen';
import { RecoveryScreen } from '../screens/RecoveryScreen';
import { ActivityScreen } from '../screens/ActivityScreen';
import { NutritionScreen } from '../screens/NutritionScreen';
import { TrendsScreen } from '../screens/TrendsScreen';
import { ProfileScreen } from '../screens/ProfileScreen';
import { HealthDebugScreen } from '../screens/HealthDebugScreen';

// HashRouter: Capacitor sirve la app como archivos estaticos sin un servidor
// que resuelva rutas, por lo que el enrutado basado en history no funciona.
export function AppRouter() {
  return (
    <HashRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route index element={<TodayScreen />} />
          <Route path="sueno" element={<SleepScreen />} />
          <Route path="recuperacion" element={<RecoveryScreen />} />
          <Route path="actividad" element={<ActivityScreen />} />
          <Route path="nutricion" element={<NutritionScreen />} />
          <Route path="tendencias" element={<TrendsScreen />} />
          <Route path="perfil" element={<ProfileScreen />} />
          <Route path="health-debug" element={<HealthDebugScreen />} />
        </Route>
      </Routes>
    </HashRouter>
  );
}
